import { useEffect, useRef } from 'react';

const CREDIT_PLAN_FEEDBACK_PENDING_KEY = 'creditplan_feedback_pending';
const CREDIT_PLAN_FEEDBACK_EVENT = 'creditplan-feedback-pending';
const CREDIT_PLAN_FEEDBACK_HOTJAR_EVENT = 'creditplan_feedback';
const CREDIT_PLAN_FEEDBACK_RETRY_INTERVAL_MS = 250;
const CREDIT_PLAN_FEEDBACK_MAX_WAIT_MS = 5000;

const useCreditPlanFeedbackSurvey = () => {
  const creditPlanSurveyInProgressRef = useRef(false);

  useEffect(() => {
    let intervalId: number | undefined;

    const triggerPendingCreditPlanSurvey = () => {
      if (creditPlanSurveyInProgressRef.current) return;
      if (sessionStorage.getItem(CREDIT_PLAN_FEEDBACK_PENDING_KEY) !== '1') return;

      creditPlanSurveyInProgressRef.current = true;
      console.info('[CreditPlanFeedback] Pending survey detected. Survey should be displayed on main site.');

      const startedAt = Date.now();
      intervalId = window.setInterval(() => {
        if (typeof window.hj === 'function') {
          window.hj('event', CREDIT_PLAN_FEEDBACK_HOTJAR_EVENT);
          sessionStorage.removeItem(CREDIT_PLAN_FEEDBACK_PENDING_KEY);
          creditPlanSurveyInProgressRef.current = false;
          console.info('[CreditPlanFeedback] Hotjar survey displayed on main site (event sent).');
          if (intervalId) window.clearInterval(intervalId);
          return;
        }

        if (Date.now() - startedAt >= CREDIT_PLAN_FEEDBACK_MAX_WAIT_MS) {
          creditPlanSurveyInProgressRef.current = false;
          console.info('[CreditPlanFeedback] Hotjar still unavailable. Survey should be displayed once Hotjar initializes.');
          if (intervalId) window.clearInterval(intervalId);
        }
      }, CREDIT_PLAN_FEEDBACK_RETRY_INTERVAL_MS);
    };

    triggerPendingCreditPlanSurvey();
    window.addEventListener(CREDIT_PLAN_FEEDBACK_EVENT, triggerPendingCreditPlanSurvey);

    return () => {
      if (intervalId) window.clearInterval(intervalId);
      window.removeEventListener(CREDIT_PLAN_FEEDBACK_EVENT, triggerPendingCreditPlanSurvey);
    };
  }, []);
};

export default useCreditPlanFeedbackSurvey;
